import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CapabilityExecutionsAnalyticsResponseDataSchema, DataResponse } from "schema"
import z from "zod"
import { CapabilityExecutionsFilters } from "./capabilityExecutionsQuery"

type Response = DataResponse<z.infer<typeof CapabilityExecutionsAnalyticsResponseDataSchema>>

const getCapabilityExecutionsAnalyticsQueryKey = (
  id?: string,
  filters?: CapabilityExecutionsFilters,
) => ["capabilityExecutionsAnalytics", id, filters]

type Params = {
  id: string
  filters?: CapabilityExecutionsFilters
}

export const capabilityExecutionsAnalyticsQuery = (params?: Params) => {
  return queryOptions({
    queryKey: getCapabilityExecutionsAnalyticsQueryKey(params?.id, params?.filters),
    queryFn: async () => {
      if (!params?.id) {
        return null
      }

      const response = await axios.get<Response>(
        `/capabilities/${params.id}/executions/analytics`,
        {
          params: {
            campaignId: params.filters?.campaignId,
            status: params.filters?.status,
            conversationType: params.filters?.conversationType,
            rangeDays: params.filters?.rangeDays ?? 7,
          },
        },
      )

      return response.data.data
    },
    enabled: !!params?.id,
  })
}
